<template>
  <div class="imgDiv" id="imgDiv">
    <img src="@/assets/images/maps.png" width="1060" height="647" id="imgPainter" />
    <div class="marker" v-for="(item, key) in data.mapList" :key="key" :style="{top: item.ordinate+'px', 'left': item.abscissa+'px'}" @click="handlerDetail(item,key)">
      <div :class="data.indexDB==key ? 'abs' : 'zb'"> </div>
      <div :class="data.indexDB==key ? 'ponints' : 'ponint'">{{data.indexDB==key ? item.point : ''}}</div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, reactive, defineEmits } from "vue";

const data = reactive({
  indexDB: 0,
  mapList:
    [
      { "id": 1, "name": "", "abscissa": 185, "ordinate": 138, "point": "黄坑镇便民服务中心" },
      { "id": 2, "name": "", "abscissa": 355, "ordinate": 349, "point": "麻沙镇便民服务中心" },
      { "id": 3, "name": "", "abscissa": 488, "ordinate": 388, "point": "莒口镇便民服务中心" },
      { "id": 4, "name": "", "abscissa": 348, "ordinate": 441, "point": "书坊乡便民服务中心" },
      { "id": 5, "name": "", "abscissa": 621, "ordinate": 516, "point": "徐市镇便民服务中心" },
      { "id": 6, "name": "", "abscissa": 621, "ordinate": 412, "point": "潭城街道便民服务中心" },
      { "id": 7, "name": "", "abscissa": 645, "ordinate": 438, "point": "宝山街道便民服务中心" },
      { "id": 8, "name": "", "abscissa": 658, "ordinate": 395, "point": "童游街道便民服务中心" },
      { "id": 9, "name": "", "abscissa": 800, "ordinate": 423, "point": "小湖镇便民服务中心" },
      { "id": 10, "name": "", "abscissa": 860, "ordinate": 328, "point": "水吉镇便民服务中心" },
      { "id": 11, "name": "", "abscissa": 713, "ordinate": 247, "point": "崇雒乡便民服务中心" },
      { "id": 12, "name": "", "abscissa": 599, "ordinate": 284, "point": "将口镇便民服务中心" },
      { "id": 13, "name": "", "abscissa": 604, "ordinate": 357, "point": "崇阳街道便民服务中心" },
      { "id": 14, "name": "", "abscissa": 640, "ordinate": 367, "point": "崇泰街道便民服务中心" },
      { "id": 15, "name": "", "abscissa": 982, "ordinate": 268, "point": "漳墩镇便民服务中心" },
      { "id": 16, "name": "", "abscissa": 920, "ordinate": 250, "point": "回龙乡便民服务中心" }
    ]
})

const emits = defineEmits(["clickFather"]);
const handlerDetail = (item, key) => {
  console.log(item, key)
  emits("clickFather", item.point);
  data.indexDB = key;
}
</script>

<style lang="scss" scoped>
.imgDiv {
  position: relative;
  height: 100%;
  width: 100%;
  height: 694px;
  background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.2)
    ),
    url("@/assets/images/map.png") no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  .marker {
    position: absolute;
    // border-radius: 50%;
    z-index: 999;
    cursor: pointer;
    // color: yellow;
    .zb {
      position: absolute;
      left: 0;
      top: 0;
      width: 26px;
      height: 28px;
      // background-color: red;
      // text-align: center;
      // line-height: 20px;
      background: url("@/assets/images/ezwaddress.png") no-repeat center;
      background-size: 100% 100%;
    }
    .abs {
      position: absolute;
      left: 0;
      top: 0;
      width: 26px;
      height: 28px;
      // background-color: red;
      // text-align: center;
      // line-height: 20px;
      background: url("@/assets/images/ezwadr.png") no-repeat center;
      background-size: 100% 100%;
    }
    .ponint {
      width: auto;
      text-align: center;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: -20px;
      font-family: Source Han Sans;
      font-size: 16.01px;
      font-weight: bold;
      line-height: normal;
      letter-spacing: 0em;
      font-variation-settings: "opsz" auto;
      font-feature-settings: "kern" on;
      color: #454b6a;
      text-shadow: 0px 3.52px 8.79px rgba(0, 0, 0, 0.3);
      // display: contents;
    }
    .ponints {
      display: inline-block;
      white-space: nowrap;
      text-align: center;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: -20px;
      font-family: Source Han Sans;
      font-size: 16.01px;
      font-weight: bold;
      line-height: normal;
      letter-spacing: 0em;
      font-variation-settings: "opsz" auto;
      font-feature-settings: "kern" on;
      color: #e66732;
      text-shadow: 0px 3.52px 8.79px rgba(0, 0, 0, 0.3);
      // display: contents;
    }
  }

  .marker:hover .ponint {
    display: block;
  }
}
</style>